// extracted by mini-css-extract-plugin
module.exports = {"main":"Toast_main__1ylCB","toast":"Toast_toast__21c9f","info":"Toast_info__3bEZF","icon":"Toast_icon__1sScS","text":"Toast_text__3Apjp","button":"Toast_button__VQsCm"};